/**
 * SkipNav — WCAG 2.4.1 (Bypass Blocks)
 *
 * Renders a visually hidden link that becomes visible on keyboard focus.
 * Place at the very top of every page layout. The #main-content anchor
 * must be placed on the <main> element of each page.
 */
export default function SkipNav() {
    return (
        <a href="#main-content" className="skip-nav">
            Skip to main content
        </a>
    );
}
